"use client";

import { useEffect, useState } from "react";

export const SetScrollbarWidth = () => {
	const [scrollbarWidth, setScrollbarWidth] = useState<number | null>(null);

	useEffect(() => {
		setTimeout(() => {
			setScrollbarWidth(window.innerWidth - document.documentElement.clientWidth);
		}, 4);
	});

	if (scrollbarWidth === null) {
		return null;
	}
	return (
		<style
			precedence="default"
			href="scrollbar-width"
		>{`:root { --scrollbar-width: ${scrollbarWidth}px; }`}</style>
	);
};
